// extracted by mini-css-extract-plugin
export default {"verifiedBox":"Verified_verifiedBox__RzDRn","wrapper":"Verified_wrapper__vmaUZ"};